/* eslint-disable jsx-a11y/anchor-is-valid */
import { ProgressBar } from 'primereact/progressbar';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { QrReader } from 'react-qr-reader';
import './styles.scss';

const FormQr = ({
  label = 'Escanear código QR',
  onAction = (data) => {},
  showModal,
  onCloseModal,
  showLoading = false,
  errorServiceMsg = '',
}) => {
  const handleScan = async (result, error) => {
    onAction({ error: !!error, dataScan: result });
  };

  return (
    <React.Fragment>
      <Modal
        show={showModal}
        onHide={onCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <h2 className="text-mex">{label}</h2>
        </Modal.Header>
        <Modal.Body>
          {showLoading && (
            <div className="row">
              <div className="col-md-3 col-12"></div>
              <div className="col-md-6 col-12">
                <h2 className="text-mex text-center">Escaneando código...</h2>
                <ProgressBar mode="indeterminate" style={{ height: '15px' }}></ProgressBar>
              </div>
              <div className="col-md-3 col-12"></div>
            </div>
          )}

          {!showLoading && (
            <div>
              <div className="row">
                <div className="col-md-3 col-12"></div>
                <div className="col-md-6 col-12">
                  <QrReader
                    facingMode={'environment'}
                    scanDelay={200}
                    onResult={(result, error) => handleScan(result, error)}
                    className="qr-style"
                  />
                </div>

                <div className="col-md-3 col-12"></div>
              </div>
              <div className="row">
                <h3 className="w-100 mt-3 text-center text-mex">
                  Por favor coloca el código QR cerca de la cámara.
                </h3>
              </div>
              {errorServiceMsg !== '' && (
                <div className="row">
                  <h3 className="w-100 mt-3 text-center" style={{ color: 'red' }}>
                    {errorServiceMsg}
                  </h3>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={onCloseModal}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default FormQr;
